import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";

import AntdTable from "../../../components/antdTable";
import BroadcastService from "../../../service/BroadcastUserService";

const BroadcastLog = () => {
  const broadcast = new BroadcastService();
  const [state, setState] = useState({
    logs: [],
    loading: true,
    filters: {},
    filteredTotal: 0,
    pageNo: 1,
    sorter: "",
    dateFilter: {},
    resetDate: false,
  });

  const filterRef = useRef(false);

  const historyColumns = [
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Action Taken",
      dataIndex: "action",
      key: "action",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Updated Field",
      dataIndex: "updatedField",
      key: "updatedField",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Updated Item",
      dataIndex: "updatedItemName",
      key: "updatedItemName",
      sorter: true,
      ellipsis: true,
      filter: false,
      width: 200,
    },
    {
      title: "Data Before Update",
      dataIndex: "dataBefore",
      key: "dataBefore",
      sorter: true,
      ellipsis: true,
      filter: false,
      width: 200,
    },
    {
      title: "Data After Update",
      dataIndex: "dataAfter",
      key: "dataAfter",
      sorter: true,
      ellipsis: true,
      filter: false,
      width: 200,
    },
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: "Update At (UTC)",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      ellipsis: true,
      filter: false,
      width: 200,
    },
  ];

  const getSuggestions = async (key, value, filters) => {
    try {
      let attribute = key;
      const startDate =
        state.dateFilter.startDate !== undefined
          ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
          : null;

      const endDate =
        state.dateFilter.endDate !== undefined
          ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
          : null;

      const data = await broadcast.getBroadcastAuditSuggestions(
        attribute,
        value,
        filters,
        startDate,
        endDate
      );

      return data.data.map((item) => ({ key: item, name: item }));
    } catch {
      return [];
    }
  };

  const applyFilters = async (filters) => {
    if (filterRef && filterRef.current) return;
    else {
      filterRef.current = true;
      setState((st) => ({ ...st, filters, loading: true }));
      try {
        const search = JSON.stringify(filters);
        const logs = await getData(state.pageNo, state.sorter, search);
        const rows = logs?.data?.rows;
        setState((st) => ({
          ...st,
          logs: rows,
          filteredTotal: logs.data.count,
          filters,
          pageNo: 1,
          total: logs.data.count,
          loading: false,
        }));
        filterRef.current = false;
        return logs.data;
      } catch (e) {
        setState((st) => ({
          ...st,
          logs: [],
          loading: false,
        }));
        filterRef.current = false;
      }
    }
  };

  const getDateFilter = (selectedDate) => {
    setState((st) => ({
      ...st,
      dateFilter: selectedDate,
      pageNo: 1,
    }));
  };

  const downloadCSV = async () => {
    const filters = JSON.stringify(state.filters);
    const startDate =
      state.dateFilter.startDate !== undefined
        ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
        : null;
    const endDate =
      state.dateFilter.endDate !== undefined
        ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
        : null;
    return broadcast.downloadXlsx(
      state.pageNo,
      15,
      state.sorter,
      filters,
      startDate,
      endDate,
      true
    );
  };

  useEffect(
    () => {
      setState((st) => ({
        ...st,
        dateFilter: st.dateFilter,
        pageNo: st.pageNo,
      }));
    },
    [state.dateFilter]
  );

  useEffect(
    () => {
      applyFilters(state.filters);
    },
    [state.dateFilter]
  );

  const getData = async (pageNo, sorter, filter, csv = false) => {
    const startDate =
      state.dateFilter.startDate !== undefined
        ? moment(state.dateFilter.startDate).format("MM-DD-YYYY")
        : null;
    const endDate =
      state.dateFilter.endDate !== undefined
        ? moment(state.dateFilter.endDate).format("MM-DD-YYYY")
        : null;
    const response = await broadcast.getBroadcastAuditLogs(
      pageNo,
      15,
      sorter,
      filter,
      startDate,
      endDate,
      csv
    );
    return response;
  };
  const onTableChange = async (pagination, _filters, sorterObj) => {
    const page = pagination.current;
    const field = sorterObj.field;
    const order = sorterObj.order
      ? sorterObj.order === "ascend"
        ? "asc"
        : "desc"
      : "";
    const sorter = field && order ? `${field}.${order}` : "";
    try {
      const pageNo = sorter !== state.sorter ? 1 : page;
      const updatedFilters = JSON.stringify(state.filters);
      const result = await getData(pageNo, sorter, updatedFilters);
      setState((st) => ({
        ...st,
        pageNo,
        logs: result.data.rows,
        sorter,
        loading: false,
      }));
    } catch (e) {
      console.error(e);
      setState((st) => ({ ...st, loading: false }));
    }
  };
  return (
    <AntdTable
      columns={historyColumns}
      data={state.logs}
      loading={state.loading}
      tableProps={{
        onChange: onTableChange,
        pagination: {
          filteredTotal: state.filteredTotal,
          current: state.pageNo,
        },
      }}
      searchPlaceholder="Search"
      getSuggestionsList={getSuggestions}
      filterFirstColumn={true}
      applyFilters={applyFilters}
      getDateFilter={getDateFilter}
      downloadCSV={downloadCSV}
      filename="broadcast_logs.xlsx"
    />
  );
};
const mapStateToProps = (state) => ({
  user: state.login.user,
});
export default withRouter(
  connect(
    mapStateToProps,
    null
  )(BroadcastLog)
);
